import { Typography } from '@mui/material'
import { TableColumn } from 'types'

export const analysisListColumns = (): TableColumn[] => [
  {
    id: 'date',
    label: 'Date',
    minWidth: 170,
    align: 'left',
    format: (value: string) => {
      return <Typography>{value}</Typography>
    },
  },
]
